<script setup lang="ts">
import AppLayout from "@/components/AppLayout.vue";
import { useNotificationsStream } from "@/composables/useNotificationsStream";

// Opens the notifications stream on client mount (SSE by default, WS behind the env flag)
useNotificationsStream();
</script>

<template>
  <AppLayout />
</template>

<style scoped>

/* App-specific styles can be added here if needed */
</style>

<style>
  .p-popover:after {
  border: none !important;
}

.p-popover::before {
  border: none !important;
}
</style>
